/**
 * Canonical content of a generated app's `src/i18n/index.ts`.
 *
 * Single source of truth shared by `ss init` (src/commands/init.ts) and the
 * i18n-neutralize-parallel-init code migration (src/migrations/…) so the two
 * can never drift: after the migration rewrites a legacy file, a later
 * `ss init --here` hashes the exact same bytes and reports it unchanged
 * instead of "modified by user".
 *
 * WHY a no-op: the @atlashub/smartstack SDK boots its OWN i18next instance on
 * the shared singleton, and its init() REPLACES the resource store. Any
 * parallel `i18next.init()` in the app (the pre-5.6 scaffold shipped one here)
 * clobbers every business bundle registered before it → pages render raw i18n
 * keys. The only surviving seam is addClientResources(), which
 * `src/extensions/moduleResources.generated.ts` calls AFTER the SDK init.
 */
export const I18N_NOOP_TEMPLATE = `/**
 * Extends the SmartStack i18n instance with this app's namespaces.
 *
 * Do NOT create a new i18next instance — the package already provides one
 * (\`@atlashub/smartstack\` → i18n) wired into react-i18next. A parallel instance
 * is silently clobbered when the SDK boots its own (its init() replaces the
 * resource store), so its translations never reach the rendering instance.
 *
 * Business-module namespaces (taches, employes, …) are registered automatically
 * by \`src/extensions/moduleResources.generated.ts\` — emitted by
 * aggregate-component-registry and imported AFTER the SDK init via
 * componentRegistry.generated.ts. Do NOT register modules here too.
 *
 * Use this file only for app-wide, non-module client resources you add by hand:
 *
 *   import { addClientResources } from '@atlashub/smartstack';
 *   import enCommon from './locales/en/common.json';
 *   import frCommon from './locales/fr/common.json';
 *   addClientResources('en', { common: enCommon });
 *   addClientResources('fr', { common: frCommon });
 */
export {};
`;
